import { useRef, useEffect, useState } from "react"
import { Helmet } from 'react-helmet-async'
import './PromoCodes.scss'
import MyVoucherSection from "components/PromoCodes/MyVoucherSection"
import AccumulatedPoints from "components/PromoCodes/AccumulatedPoints"

export default function Promotion() {
    const [istab, setTab] = useState(1)
    const [voucherReloadKey, setVoucherReloadKey] = useState(0)
    return (
        <>
            <Helmet>
                <title>Mã giảm giá - Dược Tâm Hạnh</title>
                <meta name="description" content="Khám phá và sử dụng mã giảm giá tại Dược Tâm Hạnh. Tiết kiệm hơn khi mua dược phẩm." />
            </Helmet>
            <div style={{ backgroundColor: "#f4f7fc" }}>
                <div className="styles_mainContainer__IKpR_">
                    <div className="MuiContainer-root styles_tabGuildline_container__EmSgV MuiContainer-maxWidthLg">
                        <div className="styles_tabContainer__pfgJV MuiBox-root css-0 w-full">
                            <div className="MuiTabs-root jss1 styles_tabsContainer__Gry7J">
                                <div className="MuiTabs-scrollable" style={{ width: "99px", height: "99px", position: "absolute", top: "-9999px", overflow: "scroll" }}></div>
                                <div className="MuiTabs-scroller MuiTabs-scrollable" style={{ marginBottom: "0px" }}>
                                    <div className="MuiTabs-flexContainer" role="tablist">
                                        <button className={istab === 1 ? "MuiButtonBase-root MuiTab-root jss2 MuiTab-textColorPrimary Mui-selected" : "MuiButtonBase-root MuiTab-root jss2 MuiTab-textColorPrimary"} type="button" role="tab" aria-selected="true" onClick={() => setTab(1)}>
                                            <span className="MuiTab-wrapper">Tất cả mã</span>
                                            <span className="MuiTouchRipple-root"></span>
                                        </button>
                                        <button className={istab === 2 ? "MuiButtonBase-root MuiTab-root jss2 MuiTab-textColorPrimary Mui-selected" : "MuiButtonBase-root MuiTab-root jss2 MuiTab-textColorPrimary"} type="button" role="tab" aria-selected="true" onClick={() => setTab(2)}>
                                            <span className="MuiTab-wrapper">Mã đã sử dụng</span>
                                            <span className="MuiTouchRipple-root"></span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <MyVoucherSection reloadSignal={voucherReloadKey} />
                    <AccumulatedPoints onVoucherCollected={() => setVoucherReloadKey((prev) => prev + 1)} />
                </div>
            </div>
        </>
    )
}
